import * as React from 'react'
import { SVGProps } from 'react'

const STXUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <path
      d='M33.7922 36.4459L28.6258 28.3358H36.0451V25.2719H11.7146V28.3358H19.1339L13.9675 36.4459H17.8123L23.8799 26.924L29.9474 36.4459H33.7922ZM36.0451 22.2982V19.2344H28.776L33.8824 11.2144H30.0075L23.8799 20.8864L17.7522 11.2144H13.8773L18.9837 19.2344H11.7146V22.3282L36.0451 22.2982Z'
      fill='#5546FF'
    />
  </svg>
)

export default STXUSD
